const initialState = () => {
    return {
        /**
         * @description
         * Here you should declare the state properties and it's initial values
         */
        showSpinner: false,
    }
}

export default initialState
